export async function fetchStageProgress({ userId, token, stageId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getStageProgress`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, stageId }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to load stage progress");
  }
  return resp.json();
}
